import {
	trigger,
	style,
	animate,
	transition,
	state,
} from '@angular/animations'

const animationDuration = 250

/**
 * Main area fullscreen animation (non–iframe shell only).
 * When iframe embed is active, master binds state `noop` so this trigger applies no inline styles;
 * `sk-content` top in iframe mode is driven by ContentComponent + IframeEmbedService.
 */
export const fullscreenAnimatedContent = trigger('fullscreenAnimatedContent', [
	state('noop', style({})),
	state('normal, void', style({})),
	state('full', style({
		top: 0,
		right: 0,
	})),
	transition('normal => full', [
		animate(animationDuration),
	]),
])

export const fullscreenAnimatedHeader = trigger('fullscreenAnimatedHeader', [
	state('full, void', style({
		transform: 'translateY(-100%)',
		opacity: 0,
	})),
	state('normal', style({
		transform: 'translateY(0)',
		opacity: 1,
	})),
	transition('normal => full', [
		animate(animationDuration),
	]),
])
